<template>
  <div class="hello">
    <h1>
      Compliments Button
    </h1>
    <h4>
      Press to feel loved
    </h4>
    <img v-if="this.image_up" src="../assets/simpbuttonup.png" v-on:click="getComplimented" />
    <img v-else src="../assets/simpbuttondown.png"/>
    <div>
      <img src="../assets/vana.png" width="200"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  data() {
    return {
      image_up: true,
      indexes: [],
    }
  },
  methods: {
    getComplimented: function () {
      this.image_up = false;
      if (this.indexes.length === 0){
        const numbers = [1, 2, 3, 4, 5, 6]
        this.indexes = numbers.sort(() => Math.random() - 0.5)
      }
      const index = this.indexes.pop();
      const audio = new Audio(require(`../assets/vana${index}.mp3`));
      audio.addEventListener('ended', function() {
        this.button_up();
      }.bind(this),false);
      audio.play()
    },
    button_up: function () {
      this.image_up = true;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
